import type { SimulacaoTooltipProps } from "./types-simulacao-tooltip";
import { useSimulacaoTooltip } from "./use-simulacao-tooltip";
import { SimulacaoTooltipView } from "./view-simulacao-tooltip";

/** Cartão do tooltip do selo "Simulado" (Figma 10892:402, 10892:545 e 10892:689). */
export function SimulacaoTooltip(props: SimulacaoTooltipProps) {
  const vm = useSimulacaoTooltip(props);

  return <SimulacaoTooltipView {...vm} />;
}

export type * from "./types-simulacao-tooltip";
